import { ButtonConfig } from '@antony/ng-ui/lib/models/button-config';

export const APP_ANT_BUTTON_CONFIG: ButtonConfig = {
  prefix: 'APP.ACTIONS.',
  iconSuffix: '.ICON',
  labelSuffix: '.LABEL'
};
